import { render, staticRenderFns } from "./MobileHelp.vue?vue&type=template&id=285b9088&scoped=true"
import script from "./MobileHelp.vue?vue&type=script&lang=js"
export * from "./MobileHelp.vue?vue&type=script&lang=js"
import style0 from "./MobileHelp.vue?vue&type=style&index=0&id=285b9088&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285b9088",
  null
  
)

export default component.exports